import { ReactComponent as AddIcon } from "src/images/addNewTaskIcon.svg";
import { ReactComponent as ImportIcon } from "src/images/importCSVIcon.svg";
import { media } from "src/styles/mixins";
import styled, { css } from "styled-components";
import { ReactComponent as GorrionIcon } from "src/images/taskListGorrionIcon.svg";
import { ReactComponent as _TaskIcon } from "src/images/taskIcon.svg";

export const TaskPanelWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  grid-area: tasks;
`;

export const TaskItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;

  margin-top: 15px;
  margin-right: 20px;

  :hover {
    cursor: pointer;
  }

  ${media.up("LAPTOP")`
    margin-top: 50px;
    margin-right: 48px;
  `}
  ${media.up("LAPTOP_LARGE")`
    margin-top: 110px;
    margin-right: 96px;
  `}
`;

export const TaskIcon = styled(_TaskIcon)`
  ${media.down("MOBILE_SMALL")`
    width:30px;
    height:37px;
  `}
`;

export const ItemLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};

  ${({ theme }) => css`
    ${media.down("MOBILE_SMALL")`
      line-height: ${theme.fonts.lineHeights.xxxs};
      font-size: 12px;
    `}
  `}
`;

export const TaskListPanelWrapper = styled.div<{ isVisible: boolean }>`
  background-color: ${({ theme }) => theme.colors.background};

  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  z-index: 2;
  height: calc(100vh - var(--nav-height));
  width: 100vw;

  transform: ${({ isVisible }) =>
    isVisible ? "translateX(0%)" : "translateX(calc(100% + 6px))"};
  transition: 0.4s ease-out;
  padding: 0 15px;

  ${({ theme }) => css`
    ${media.up("LAPTOP")`
      height: calc(100% - 14px * 2);
      margin: 14px 6px 14px;
      width: 380px;
      padding: 0 25px;
      border-radius: ${theme.borderRadius.l};
      border: ${theme.border.thin} solid ${theme.colors.primary};
    `}
  `}

  ${media.up("LAPTOP_LARGE")`
   width: 430px;
  `}

  ${media.up("LAPTOP_EXTRA_LARGE")`
   width: 550px;
  `}
`;

export const TaskLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
`;

export const UpperRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;

  ${media.up("LAPTOP_LARGE")`
    margin-top:40px;
  `}
`;

export const TaskAddIcon = styled(AddIcon)`
  margin-right: 10px;
  justify-self: flex-start;
`;

export const AddNewTaskWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;
`;

export const TaskImportIcon = styled(ImportIcon)`
  margin-left: 11px;
  justify-self: flex-start;
`;

export const ImportFromCSVWrapper = styled.div<{ isVisible: boolean }>`
  display: flex;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  flex-direction: row;
  align-items: center;

  margin-top: 41px;
  height: fit-content;
  width: fit-content;

  :hover {
    cursor: pointer;
  }
`;

export const CSVFileInput = styled.input`
  display: none;
`;

export const TaskPanelContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  margin-top: 30px;

  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.agreement.progressBg};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const TaskListGorrionIcon = styled(GorrionIcon)`
  align-self: flex-end;
  margin-bottom: 22px;
  display: none;

  ${media.up("LAPTOP")`
    display:block;
  `}
`;
